import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import OrderItem from '../../components/UI/OrderItem';

import { FONT } from '../../styles/color';
import { Medium } from '../../components/UI/Text';
import { useFetch } from '../../hooks/useFetch';
import { orderApi } from '../../api/order';

const Container = styled.div`
	width: 90%;
	max-width: 900px;
	display: flex;
	flex-direction: column;
`;

const Notice = styled.div`
	width: 100%;
	height: 120px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const OrderWrapperContainer= styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

function OrderWrapper(props) {
	return (
		<OrderWrapperContainer>
			{ props.children }
		</OrderWrapperContainer>
	);
};

// TODO: 페이징 처리
export default function OrderList(props) {
	const navigate = useNavigate();
	const { data, loading, error } = useFetch(orderApi.getOrderList, []); 

	if(loading) {
		return ;
	}

	if(error) {
		alert('주문 내역 로드에 실패했습니다.');
		navigate('/');
		return ;
	}

	const orders = data.orderList || [];
	console.log(orders);

	const onClickItem = (orderId) => {
		navigate(`/my/orders/${ orderId }`);
	}

  	return (
		<Container>
			<Notice>
				<Medium size="18px" color={ FONT.deep01 }>최근 6개월 내의 내역만 조회됩니다.</Medium>
			</Notice>
			<OrderWrapper>
				{
					orders.map((order) => (
						<OrderItem 
							key={ order.orderNumber }
							data={ order }
							onClick={ () => onClickItem(order.orderNumber) }
						/>
					))
				}
			</OrderWrapper>
		</Container>
  	);
}
